export default "__VITE_ASSET__Dwse3jKA__"